import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getWarehousesActionAsync } from '../redux/actions/warehouseActions'

export const useWarehouses = () => {
  const { warehousesState } = useSelector((state: RootState) => state.warehouse)
  const dispatch = useDispatch()

  const getWarehouses = () => {
    dispatch(getWarehousesActionAsync())
  }

  return { warehousesState, getWarehouses }
}
